import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Warning, CheckCircle, Schedule } from '@mui/icons-material';
import { colors } from '../../themes/typography';

/**
 * Reusable AlertBadge component
 * Displays a badge with alert status icon and tooltip
 */
const AlertBadge = ({ alert, t }) => {
  if (!alert) return null;

  const getAlertIcon = (alert) => {
    // Use the status field for accurate status determination
    switch (alert.status) {
      case 'resolved':
      case 'not_apply':
        return <CheckCircle sx={{ fontSize: '10px', color: '#34C759' }} />; // Apple green
      case 'under_review':
        return <Warning sx={{ fontSize: '10px', color: '#FF9500' }} />; // Apple orange
      case 'pending':
      default:
        return <Schedule sx={{ fontSize: '10px', color: '#8E8E93' }} />; // Apple gray
    }
  };

  const getAlertTooltip = (alert, t) => {
    // Use the status field for accurate status determination
    switch (alert.status) {
      case 'resolved':
        return t ? t('resolved') : 'Issue resolved';
      case 'not_apply':
        return t ? t('notBroken') : 'Working normally';
      case 'under_review':
        return t ? t('underReview') : 'Issue reported';
      case 'pending':
      default:
        return t ? t('pending') : 'Awaiting review';
    }
  };

  return (
    <Tooltip title={getAlertTooltip(alert, t)} arrow>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: colors.text.secondary,
        cursor: 'help',
      }}>
        {getAlertIcon(alert)}
      </Box>
    </Tooltip>
  );
};

export default AlertBadge;